module.exports = __webpack_public_path__ + "img/c07_scout2_Normal_ua.f7ab7095.webp";